
//import ConstUtils from '@/utils/ConstUtils.js';
import SortUtils from "../SortUtils";

export default class InvoiceUtils extends SortUtils {

  static SortByTotal = function(a,b) {
    if (a == null || b == null) {
      return 0;
    }
    if (a.total() > b.total()) {
      return 1;
    }
    if (a.total() < b.total()) {
      return -1;
    }
    return 0;
  }
  
  static SortByTotalDesc = function(a,b) {
    if (a == null || b == null) {
      return 0;
    }
    if (a.total() < b.total()) {
      return 1;
    }
    if (a.total() > b.total()) {
      return -1;
    }
    return 0;
  }
  
  static SortByCreatedDate = function(a, b) {
    if (a == null || b == null) {
      return 0;
    }
    if (a.createdDate() < b.createdDate()) {
      return 1;
    }
    if (a.createdDate() > b.createdDate()) {
      return -1;
    }
    return 0;
  }

  static SortByModifiedDate = function(a, b) {
    if (a == null || b == null) {
      return 0;
    }
    if (a.modifiedDate() > b.modifiedDate()) {
      return -1;
    }
    if (a.modifiedDate() < b.modifiedDate()) {
      return 1;
    }
    return 0;
  }
  
  static SortBy_invoiceNumberZa = function(a,b) {
    return SortUtils.SortByDesc("number", a, b);
  }

  static SortBy_numberZa = function(a,b) {
    return SortUtils.SortByDesc("number", a, b);
  }

  static SortBy_invoiceNumberAz = function(a,b) {
    return SortUtils.SortBy("number", a, b);
  }

  static SortBy_numberAz = function(a,b) {
    return SortUtils.SortBy("number", a, b);
  }

  static SortBy_Company_contractStartZa = function(a, b) {
    return InvoiceUtils.SortByCompanyStartDesc(a,b)
  }

  static SortBy_Company_contractStartAz = function(a, b) {
    return InvoiceUtils.SortByCompanyStartAsc(a,b)
  }

  static SortByCompanyStartAsc = function(a, b) {
    if (a == null || b == null) {
      return 0;
    }

    let aValue = b.company().find().contractStart();
    let bValue = a.company().find().contractStart();

    
    if (aValue > bValue) {
      return -1;
    }
    
    if (aValue < bValue) {
      return 1;
    }
    
    return 0;
  }

  static SortByCompanyStartDesc = function(a, b) {
    if (a == null || b == null) {
      return 0;
    }

    let aValue = a.company().find().contractStart();
    let bValue = b.company().find().contractStart();

    
    if (aValue > bValue) {
      return -1;
    }
    
    if (aValue < bValue) {
      return 1;
    }
    
    return 0;
  }

  static SortBy_createdDateAz = function(a, b) {
    var result = SortUtils.SortBy_createdDateAz(a,b);
    if (result == 0) {
      if (a.company && b.company) {
        let ac = a.company().find();
        let bc = b.company().find();
        result = SortUtils.SortBy_nameAz(ac,bc);
      }
    }
    return result;
  }

  static SortBy_createdDateZa = function(a,b) {
    var result = SortUtils.SortBy_createdDateZa(a,b);
    if (result == 0) {
      if (a.company && b.company) {
        let ac = a.company().find();
        let bc = b.company().find();
        result = SortUtils.SortBy_nameAz(ac,bc);
      }
    }
    return result;
  }
}